export enum EPortalType {
    GOOGLE = 'google',
    NAVER = 'naver',
    KAKAO = 'kakao',
    FACEBOOK = 'facebook',
}